<template>
  <v-card data-cy="dataset-license-card">
    <v-card-title class="headline primary white--text">
        License
    </v-card-title>
    <v-card-text :class="{ presentation: getPresentMode }">
      <v-textarea
        v-if="editMode"
        box
        label="License"
        :hint="`${licenseLength}/3000 Characters`"
        v-model="datasetLicense"
        data-cy="license-textarea"
        :error-messages="textFieldOptionalErrors($v.datasetLicense)"
        @input="$v.datasetLicense.$touch()"
        @blur="$v.datasetLicense.$touch()"
      >
      </v-textarea>
      <template v-else>
        <template>
          <vue-markdown v-bind:source="whichLicense"></vue-markdown>
        </template>
      </template>
    </v-card-text>
    <v-card-actions v-if="truncateLicense && !editMode">
      <v-flex text-xs-center class="my-0">
        <v-btn 
          flat 
          small 
          color="primary"
          class="my-0"
          @click="licenseShown = !licenseShown"
        >
          {{ licenseShown ? 'Hide' : 'Show' }}
        </v-btn>
      </v-flex>  
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '../validators.js'
import VueMarkdown from 'vue-markdown'

export default {
  mixins: [validationMixin],
  components: {
    VueMarkdown
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    datasetLicense: {
      maxLength: maxLength(3000)
    }
  },
  mounted () {
    this.$watch('$v', (newVal, oldVal) => {
        this.setTopFieldsInvalid(newVal.$invalid)
      }, { deep: true })
  },
  data () {
    return {
      licenseShown: false
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentDataset',
      'getDatasetEdits',
      'getPresentMode'
    ]),
    datasetLicense: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_license
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_license',
          value: val
        })
      }
    },
    first250 () {
      let license = this.datasetLicense
      if (license) {
        return license.substring(0, 250) + '...'
      } else {
        return ''
      }
    },
    truncateLicense () {
      return this.datasetLicense ? this.datasetLicense.length > 250 : false
    },
    licenseLength () {
      return this.datasetLicense ? this.datasetLicense.length : 0
    },
    whichLicense() {
      return this.licenseShown ? this.datasetLicense :  this.first250
    }
  },
  methods: {
    ...mapMutations([
      'setDatasetEdit',
      'setTopFieldsInvalid'
    ])
  }
}
</script>